import { icon, Icon } from '../lib/fa-icons.js';
import Widget from "./base.js";
import { getCookie, setCookie } from "tpm-utils";

export class MegaSaleBumper extends Widget {
	componentWillMount() {
		const modalDismissed = getCookie("tpm_megasale_modal_dismissed");
		const bumperDismissed = getCookie("tpm_megasale_bumper_dismissed");

		if (modalDismissed) {
			this.state.dismissed = false;
		} else {
			this.state.dismissed = true;
		}
		if (this.props.nomodalcheck) this.state.dismissed = false;

		if (bumperDismissed) this.state.dismissed = true;

		if (this.state.dismissed) return;

		this.dismiss = this.dismiss.bind(this);
	}

	dismiss() {
		this.setState({ dismissed: true }, () => {
			/* 
			if the modal has been dismissed, then we let this dismiss
			this logic keeps this on the fp until the user has dismissed the Modal, then dismissed the bumper
			*/
			const modalDismissed = getCookie("tpm_megasale_modal_dismissed");
			if (modalDismissed) setCookie("tpm_megasale_bumper_dismissed", "1", 1);
		});
	}

	renderContent() {
		if (this.state.dismissed) return;

		return (
			<div className="MegaSaleBumper__Inner">
				<div className="MegaSaleBumper__Neon --outer"></div>
				<div className="MegaSaleBumper__Neon --inner"></div>
				<div className="MegaSaleBumper__Dismiss" onClick={this.dismiss}>
					<span style="pointer-events: none">
						<Icon name="xmark" style="light" />
					</span>
				</div>
				<div className="MegaSaleBumper__Container --mobile">
					<img
						class="MegaSaleModal__Logo"
						src={`${document.location.origin}/wp-content/themes/tpm25/assets/images/megasale/mega-sale-1-year-white.png`}
						alt="One Year to Election Mega Sale"
					/>
					<a
						className="Button --red"
						href={`${document.location.origin}/memberships?utm_source=on_site&utm_medium=megasale&utm_campaign=memberships`}
					>
						30% Off Memberships
					</a>
				</div>
				<div className="MegaSaleBumper__Container --desktop">
					<div className="MegaSaleBumper__Left">
						<img
							class="MegaSaleBumper__Img"
							src={`${document.location.origin}/wp-content/themes/tpm25/assets/images/megasale/mega-sale-modal-image.png`}
							alt="One Year to Election Mega Sale"
						/>
					</div>
					<div className="MegaSaleBumper__Right">
						<div className="MegaSaleBumper__Heading">
							At TPM we do elections different.
						</div>
						<a
							className="Button --red"
							href={`${document.location.origin}/memberships?utm_source=on_site&utm_medium=megasale&utm_campaign=memberships`}
						>
							30% Off Annual Memberships
						</a>
					</div>
				</div>
			</div>
		);
	}
}
